import React from 'react'
import styles from './styles'
import { Box, Typography, withStyles } from '@material-ui/core'

const Header = props => {
  const { classes } = props

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>
        Upgrade your plan to create impact
        <br />
        and grow your business.
      </Typography>
    </Box>
  )
}

export default withStyles(styles)(Header)
